import { ReactElement } from 'react';
import * as React from 'react';

import styles from './loyalty-how-to-gain-points-modal.module.scss';
import { Popin } from '@utmb/design-system/popin/Popin';
import { LoyaltyHowToGainPoint } from '../LoyaltyHowToGainPoints';
import { LoyaltyLevelEnum } from '@utmb/types/enum/LoyaltyLevelEnum';
import LoyaltyRuleView from '@utmb/types/view/LoyaltyRuleView';
import { Font } from '@utmb/design-system/text/font';
import { getColorStyle } from '@utmb/utils/colors';
import { ColorTypesEnum } from '@utmb/types/colors';
import { useTranslation } from 'next-i18next';
interface LoyaltyHowToGainPointsModalProps {
    isOpen: boolean;
    close: () => void;
    currentLevel: LoyaltyLevelEnum;
    loyaltyRules: LoyaltyRuleView;
}

export const LoyaltyHowToGainPointsModal = ({ isOpen, close, currentLevel, loyaltyRules }: LoyaltyHowToGainPointsModalProps): ReactElement | null => {
    const { t } = useTranslation('myutmb');
    return isOpen ? (
        <Popin closeCallback={() => close()} isGrey>
            <div className={styles.loyaltyHowToGainPointsModal}>
                <Font.FuturaBold className={styles.title} desktop="24" mobile="24" color={getColorStyle(ColorTypesEnum.PRIMARY)}>
                    {t('myUtmb.howToGainPoints.link')}
                </Font.FuturaBold>
                <LoyaltyHowToGainPoint currentLevel={currentLevel} loyaltyRules={loyaltyRules} />
            </div>
        </Popin>
    ) : null;
};
